module.exports = __webpack_public_path__ + "static/media/APP_LifeSaver_152x174_1.3b16fb76.png";